import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/

/**
 * @type {class}
 * @desc OutboundCalls defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { OutboundCallsService } from 'services/outboundCalls';
 *
 * // create service instance and send/cancel request
 * const outboundCallsService = new OutboundCallsService();
 * const result = await outboundCallsService.fetchData( '<user-id>' ); // fetch data
 * outboundCallsService.cancel(); // cancel an active request
 */
export class OutboundCallsService extends HttpService {

    // submit form data
    async submitFormData( { url, data } ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: data
            } );
    
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE )
            };
        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE
            };
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
